(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  const ReadMore = (() => {
    let s;

    return {
      settings() {
        return {
          content: document.querySelectorAll('.js-read-more'),
          originalContentArr: [],
          truncatedContentArr: [],
          moreLink: 'Read More',
          lessLink: 'Read Less'
        };
      },

      init() {
        s = this.settings();
        this.bindEvents();
      },

      bindEvents() {
        this.truncateText();
      },

      countWords(str) {
        return str.split(/\s+/).length;
      },

      ellipseContent(str, wordsNum) {
        return str.split(/\s+/).slice(0, wordsNum).join(' ') + '.';
      },

      truncateText() {
        for (let i = 0; i < s.content.length; i++) {
          const originalContent = s.content[i].innerHTML;
          const numberOfWords = s.content[i].dataset.rmWords;
          const truncatedContent = this.ellipseContent(originalContent, numberOfWords);
          const originalContentWords = this.countWords(originalContent);

          s.originalContentArr.push(originalContent);
          s.truncatedContentArr.push(truncatedContent);

          if (numberOfWords < originalContentWords) {
            s.content[i].innerHTML = s.truncatedContentArr[i];
            this.createLink(i);
          }
        }
        this.handleClick(s.content);
      },

      createLink(index) {
        const linkWrap = document.createElement('span');

        linkWrap.className = 'read-more__link-wrap';
        linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;

        s.content[index].appendChild(linkWrap);
      },

      handleClick(el) {
        const readMoreLinks = document.querySelectorAll('.read-more__link');

        for (let j = 0; j < readMoreLinks.length; j++) {
          readMoreLinks[j].addEventListener('click', function () {
            const moreLinkID = this.getAttribute('id');
            const index = moreLinkID.split('_')[1];

            el[index].classList.toggle('is-expanded');

            if (this.dataset.clicked !== 'true') {
              el[index].innerHTML = s.originalContentArr[index];
              el[index].appendChild(this.parentNode); // Re-append the link to the content
              this.innerHTML = s.lessLink;
              this.dataset.clicked = true;
            } else {
              el[index].innerHTML = s.truncatedContentArr[index];
              el[index].appendChild(this.parentNode); // Re-append the link to the content
              this.innerHTML = s.moreLink;
              this.dataset.clicked = false;
            }
          });
        }
      }
    };
  })();

  ReadMore.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const ReadMore = (() => {
    let s;

    return {
      settings() {
        return {
          content: document.querySelectorAll('.js-read-more'),
          originalContentArr: [],
          truncatedContentArr: [],
          moreLink: 'Read More',
          lessLink: 'Read Less'
        };
      },

      init() {
        s = this.settings();
        this.bindEvents();
      },

      bindEvents() {
        this.truncateText();
      },

      countWords(str) {
        return str.split(/\s+/).length;
      },

      ellipseContent(str, wordsNum) {
        return str.split(/\s+/).slice(0, wordsNum).join(' ') + '.';
      },

      truncateText() {
        for (let i = 0; i < s.content.length; i++) {
          const originalContent = s.content[i].innerHTML;
          const numberOfWords = s.content[i].dataset.rmWords;
          const truncatedContent = this.ellipseContent(originalContent, numberOfWords);
          const originalContentWords = this.countWords(originalContent);

          s.originalContentArr.push(originalContent);
          s.truncatedContentArr.push(truncatedContent);

          if (numberOfWords < originalContentWords) {
            s.content[i].innerHTML = s.truncatedContentArr[i];
            this.createLink(i);
          }
        }
        this.handleClick(s.content);
      },

      createLink(index) {
        const linkWrap = document.createElement('span');

        linkWrap.className = 'read-more__link-wrap';
        linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;

        s.content[index].appendChild(linkWrap);
      },

      handleClick(el) {
        const readMoreLinks = document.querySelectorAll('.read-more__link');

        for (let j = 0; j < readMoreLinks.length; j++) {
          readMoreLinks[j].addEventListener('click', function () {
            const moreLinkID = this.getAttribute('id');
            const index = moreLinkID.split('_')[1];

            el[index].classList.toggle('is-expanded');

            if (this.dataset.clicked !== 'true') {
              el[index].innerHTML = s.originalContentArr[index];
              el[index].appendChild(this.parentNode); // Re-append the link to the content
              this.innerHTML = s.lessLink;
              this.dataset.clicked = true;
            } else {
              el[index].innerHTML = s.truncatedContentArr[index];
              el[index].appendChild(this.parentNode); // Re-append the link to the content
              this.innerHTML = s.moreLink;
              this.dataset.clicked = false;
            }
          });
        }
      }
    };
  })();

  ReadMore.init();

  } catch(e) { console.error(e); }
})();
})();
